/*global angular, location */

(function (angular) {
'use strict';

var services = angular.module('adminHelper.services', [
    'ngResource'
]);


services.factory('ObjectList', ['$resource', function ($resource) {

    return $resource('/api/admin/helper/:id/:objects_type', null, {
        'get': {
            method: 'GET',
            cache: true
        }
    });

}]);


}(angular));